import { render, staticRenderFns } from "./TreeCollapseItem.vue?vue&type=template&id=405aab70&scoped=true&"
import script from "./TreeCollapseItem.vue?vue&type=script&lang=js&"
export * from "./TreeCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./TreeCollapseItem.vue?vue&type=style&index=0&id=405aab70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405aab70",
  null
  
)

export default component.exports